"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTopicCuratorForUser = isTopicCuratorForUser;
/** Куратор темы — назначение на тему (`topic.curator.id`), не группа 20. */
function isTopicCuratorForUser(curatorUserId, currentUserId) {
    const curatorId = curatorUserId ?? 0;
    return curatorId > 0 && currentUserId != null && curatorId === currentUserId;
}
